import React from 'react';
import CustomDateFormatter from "../../../../../../utils/dateTimeFormatter";
import { differenceInDays } from '../../../../../../utils';

const DateInfo = ({ dateCreated, updatedAt }) => {
  return (
    <div className="created-date-box">
      <div className="created-date">
        Created <CustomDateFormatter date={dateCreated} />
        <div className="updated-date">
          Updated{' '}
          {differenceInDays(updatedAt) > 0
            ? `${differenceInDays(updatedAt)} days ago`
            : 'Today'}{' '}
        </div>
      </div>
    </div>
  );
};

export default React.memo(DateInfo);
